<template>
  <ims-modal
    :title="$store.state.interact.modals.manageLeagues.title"
    :canClose="true"
    :show="$store.state.interact.modals.manageLeagues.show"
    :onClose="close"
  >
    <main v-if="$store.state.interact.modals.manageLeagues.show">
      <section class="available-leagues">
        <ims-item class="divider">Available Exclusive Leagues</ims-item>
        <ims-item class="pad" v-if="availableLeagues.length == 0">
          <strong>No Leagues are currently available.</strong> Check back soon.
        </ims-item>
        <ims-item v-for="league in availableLeagues" :key="`available_${league.id}`" class="pad">
          <template v-slot:left>
            <div v-if="league.isPrivate">
              <ims-icon icon="lock" size="md" class="pl-1 text-faded" />
            </div>
            <img
              class="brand-badge"
              height="40"
              v-if="league.isOfficial && league.isFirestone"
              :src="$Brand.get('firestone').badgeUrl"
              :alt="`badge`"
            />
            <img
              class="brand-badge"
              height="40"
              v-else-if="league.isOfficial && !league.isFirestone"
              :src="$Brand.get('indycar').badgeUrl"
              :alt="`badge`"
            />
          </template>
          <h1>{{ league.name }}</h1>
          <template v-slot:right>
            <ims-button type="clear" color="primary" @click="joinLeague(league)">Join</ims-button>
          </template>
        </ims-item>
      </section>
    </main>
  </ims-modal>
</template>

<script>
/**
 * TODO: RENAME THIS COMPONENT.
 * it's now Join a public league
 * don't ask how we got here - it was around and around
 * and now we're here - without much time to clean up some
 * of these hangnails. Sorry future devs! Godspeed.
 */
export default {
  data() {
    return {
      availableLeagues: []
    };
  },
  computed: {
    myLeagues() {
      return this.$store.state.leagues.mine;
    }
  },
  watch: {
    '$store.state.interact.modals.manageLeagues.show'(show) {
      this.init();
    }
  },
  methods: {
    async init() {
      let available = await this.$User.service.getPublicLeagues();
      let mine = await this.$User.service.getMyLeagues();
      // if Available - do some magic
      if (available) {
        this.availableLeagues = available
          // Filter out isMember and isPrivate
          .filter(league => {
            return !league.isMember && !league.isPrivate;
          })
          .filter(league => {
            // filter out my leagues - consider removing when isMember working properly
            return !mine.find(myleague => league.id == myleague.id);
          })
          // Sort the results
          .sort((a, b) => {
            if (a.isOfficial || b.isOfficial) return 1;
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
          });
      }
      this.$forceUpdate();
    },
    close() {
      this.$store.commit('modals/manageLeagues', null);
    },
    async joinLeague(league) {
      // Show Loader

      let joined = await this.$store.dispatch('leagues/public/join', league);
      await this.$store.dispatch('leagues/mine/load');
      if (joined) {
        this.init();
      }
    }
  },
  mounted() {
    if (this.$store.state.interact.modals.manageLeagues.show) {
      this.init();
    }
    //
  }
};
</script>

<style lang="scss">
.league-logo {
  width: 48px;
  height: 32px;
  background: #eee;
  border-radius: 4px;
}
.available-leagues {
  .item-start {
    margin-right: -10px; // force icon and iconless labels to line up
  }
}
</style>
